module.exports = __webpack_public_path__ + "static/media/17_6.0f7e777f.jpg";